import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import YearsSeal from "@/components/YearsSeal";
import { CheckCircle2 } from "lucide-react";

const SERVICES = [
  "Advertising Agency",
  "Newspaper Advertisement",
  "Bank Notice Publication",
  "Radio Advertising",
  "Outdoor Ads",
  "Media Planning",
  "Branding & Marketing Services",
  "Network of major newspapers — Pan India",
  "Rural & Urban Advertising in Maharashtra",
];

export default function About() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        {/* Hero */}
        <section className="bg-navy-deep text-parchment">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-24 grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="text-[10px] tracking-overline uppercase text-white/70 font-bold mb-3">About Welworth</div>
              <h1 className="font-display text-5xl lg:text-7xl leading-[0.95] font-semibold">
                Your reliable partner
                <span className="block italic text-white/80 font-normal">for publishing ads since 1964.</span>
              </h1>
              <p className="mt-7 text-white/80 leading-relaxed text-lg max-w-2xl">
                Welworth has been servicing more than <strong className="text-white">200 clients</strong> in Media Planning, Branding &amp; Marketing Services — with a pan-India presence in Print Media.
              </p>
            </div>
            <div className="lg:col-span-5 flex lg:justify-end">
              <YearsSeal size={180} />
            </div>
          </div>
        </section>

        {/* Body */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-10">
            <div className="prose prose-slate prose-lg max-w-none">
              <p className="text-xl text-slate-700 leading-relaxed font-display italic">
                Welworth Creative Media has been servicing to more than 200 clients in terms of Media Planning, Branding &amp; Marketing Services. Welworth boasts a pan-India presence in terms of Print Media.
              </p>

              <p className="text-slate-700 leading-relaxed mt-6">
                We are a full-service advertising agency working across newspaper advertisements, radio, outdoor ads, and bank notice publications — with a network covering all major newspaper publications in India. As a leading ad agency for rural and urban advertisement in Maharashtra, with <strong>60+ years of experience</strong>, we are your reliable partner for publishing ads since <strong>1964</strong>.
              </p>
            </div>

            {/* services grid */}
            <div className="mt-14">
              <div className="text-[10px] tracking-overline uppercase text-gold font-bold mb-4">What we offer</div>
              <div className="grid sm:grid-cols-2 gap-3" data-testid="about-services-list">
                {SERVICES.map((s) => (
                  <div key={s} className="flex items-start gap-3 p-4 bg-white border border-slate-200 rounded-sm">
                    <CheckCircle2 size={18} className="text-gold mt-0.5 shrink-0"/>
                    <span className="text-navy-deep">{s}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Pull quote */}
            <div className="mt-16 p-7 bg-parchment border-l-4 border-gold">
              <div className="text-[10px] tracking-overline uppercase text-gold font-bold">Our promise</div>
              <p className="mt-2 font-display text-2xl text-navy-deep italic leading-tight">
                &ldquo;Six decades on, we still treat every ad — however small — as if our own name were on it.&rdquo;
              </p>
            </div>

            {/* stats strip */}
            <div className="mt-12 grid grid-cols-3 gap-4 text-center" data-testid="about-stats-strip">
              <Stat n="60+" t="Years in print" />
              <Stat n="200+" t="Active clients" />
              <Stat n="9+" t="Partner dailies" />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

function Stat({ n, t }) {
  return (
    <div className="bg-white border border-slate-200 rounded-sm p-6">
      <div className="font-display text-4xl lg:text-5xl text-navy-deep">{n}</div>
      <div className="text-[10px] tracking-overline uppercase text-gold font-bold mt-1">{t}</div>
    </div>
  );
}
